import { BlockedIcon } from '../icons'

export const AccountBlocked = () => {
    return (
        <div className='flex flex-col items-center mb-8'>
            <h2 className='text-red-500 flex items-center gap-2'>
                <span>
                    Account is blocked
                </span>

                <BlockedIcon />
            </h2>

            <p className='text-red-500 mb-8'>
                Too many attempts entering the wrong information.
            </p>

            <p>
                If you believe there is an error, please contact support.
            </p>
        </div>
    )
}